const itemFormModel = {
  formId: 'itemForm',
  formField: {
    description: {
      name: 'description',
      label: 'Description',
      required: true,
      requiredErrorMsg: 'Description is required',
    },
    quantityUnit: {
      name: 'quantityUnit',
      label: 'Unit',
      required: true,
      requiredErrorMsg: 'Quantity Unit is required',
    },
    categoryId: {
      name: 'categoryId',
      label: 'Category',
      required: true,
      requiredErrorMsg: 'Category is required',
    },
    itemCode: {
      name: 'itemCode',
      label: 'Item Code',
      required: true,
      requiredErrorMsg: 'itemCode is required',
    },
    itemCost: {
      name: 'itemCost',
      label: 'Item Cost',
      required: true,
      requiredErrorMsg: 'itemCost is required',
    },
    inventoryId: {
      name: 'inventoryId',
      label: 'inventory Code',
      required: true,
      requiredErrorMsg: 'inventory Code is required',
    },

    inventoryCode: {
      name: 'inventoryCode',
      label: 'inventory Code',
      required: true,
      requiredErrorMsg: 'Inventory Code is required',
    },

    inventoryDescription: {
      name: 'inventoryDescription',
      label: 'inventoryDescription',
      required: true,
      requiredErrorMsg: 'Inventory Description is required',
    },

    categoryCode: {
      name: 'categoryCode',
      label: 'Category Code',
      required: true,
      requiredErrorMsg: 'Category Code is required',
    },
    categoryDescription: {
      name: 'categoryDescription',
      label: 'Category Description',
      required: true,
      requiredErrorMsg: 'Category Description is required',
    },
    isService: {
      name: 'isService',
      required: true,
    },
  },
  initialValues: {
    itemCode: '',
    description: '',
    quantityUnit: '',
    categoryId: '',
    itemCost: 0,
    inventoryId: '',
    inventoryCode: '',
    inventoryDescription: '',
    categoryCode: '',
    categoryDescription: '',
    isService:false
  },
};

export type createItemModelType = {
  itemCode: string;
  description: string;
  quantityUnit: string;
  categoryId: string;
  itemCost: number;
  inventoryId: string;
  inventoryCode: string;
  inventoryDescription:string,
  categoryCode:string,
  categoryDescription:string,
  isService: boolean;
};

export default itemFormModel;
